import React, { useState, useEffect } from 'react';
import {
  Form, Input, Button, Layout, Row, Col, Card, Breadcrumb, message, Switch, Space, Menu,
} from 'antd';
import { Link, Redirect } from 'react-router-dom';
import Axios from 'axios';
import moment from 'moment';
import _ from 'underscore';
import { url } from '../../config/global';

const { Content } = Layout;
const { TextArea } = Input;
const { SubMenu } = Menu;

const layout = {
  labelCol: {
    lg: 8,
    md: 10,
  },
  wrapperCol: {
    lg: 14,
    md: 14,
  },
};
const tailLayout = {
  wrapperCol: {
    offset: 8,
    span: 16,
  },
};

function CreateRole(props) {
  const [data, setData] = useState({
    name: '',
    description: '',
  });

  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [permissions, setPermissions] = useState([]);
  const [rolePermission, setRolePermission] = useState([]);
  // const [setExpandedKeys] = useState([]);
  // const [setCheckedKeys] = useState([]);
  // const [setSelectedKeys] = useState([]);
  // const [setAutoExpandParent] = useState(true);

  // const onExpand = (expandKeys) => {
  //   setExpandedKeys(expandKeys);
  //   setAutoExpandParent(false);
  // };

  // const onCheck = (checkKeys) => {
  //   setCheckedKeys(checkKeys);
  //   const dataPermission = checkKeys.map((checkedKey) => ({
  //     permission_id: checkedKey,
  //     allow: true,
  //   }));
  //   setRolePermission(dataPermission);
  // };

  const handleChange = (name, value) => {
    setError(null);
    setData({
      ...data,
      [name]: value,
    });
  };

  const handleChangeSwitch = (name, value) => {
    setRolePermission({
      ...rolePermission,
      [name]: value,
    });
  };
  
  const onSaveData = () => {
    setLoading(true);

    Axios.post(
      `${url}/role`,
      {
        name: data.name,
        description: data.description,
        permissions: rolePermission,
      },
      {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem('token')}`,
        },
      },
    )
      .then((res) => {
        message.success(res.data.message);
        props.history.push('/role');
      })
      .catch((err) => {
        if (err.response) {
          message.error(err.response.data.message);
          if (err.response.status === 422) {
            setError(err.response.data.errors);
          }
          if (err.response.status === 401) {
            sessionStorage.removeItem('token');
          }
        }
        setLoading(false);
      });
  };

  const handleReset = () => {
    setData({
      description: '',
      name: '',
    });
  };

  const getPermission = () => {
    setLoading(true);

    Axios.get(`${url}/permission/list-permission-parent`, {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem('token')}`,
      },
    })
      .then((res) => {
        setPermissions(res.data.data);
      })
      .catch((err) => {
        console.log(err.response);
        if (err.response) {
          message.error(err.response.data.message);
          if (err.response.status === 422) {
            setError(err.response.data.errors);
          }
          if (err.response.status === 401) {
            sessionStorage.removeItem('token');
          }
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getPermission();
  }, []);

  if (!sessionStorage.getItem('token')) {
    return <Redirect to="/login" />;
  }

  return (
    <>
      <Content className="content m-0">
        <Row>
          <Col xs={24}>
            <Card className="body-data">
              <Form {...layout} labelAlign="left" name="control-hooks" onFinish={onSaveData}>
                <Row>
                  <>
                    <Col xs={24} md={12}>
                      <Form.Item
                        required
                        label="Name"
                        validateStatus={error && error.name ? 'error' : false}
                        help={error && error.name ? error.name[0] : false}
                      >
                        <Input
                          value={data.name}
                          onChange={(e) => handleChange('name', e.target.value)}
                        />
                      </Form.Item>
                      <Form.Item
                        label="Description"
                        validateStatus={error && error.description ? 'error' : false}
                        help={
                          error && error.description ? error.description[0] : false
                        }
                      >
                        <TextArea
                          value={data.description}
                          onChange={(e) => handleChange('description', e.target.value)}
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} md={12}>
                      <Form.Item label="Permissions">
                        {_.chunk(permissions, 2).map((chunk, index) => (
                          <div key={Math.random()}>
                            {chunk.map((permission) => (
                              <Menu
                                style={{ borderRight: 'transparent' }}
                                key={Math.random()}
                                mode="inline"
                                className="menu-permission"
                              >
                                {permission.children === 0 ? (
                                  <Menu.Item key={permission._id}>
                                    <Space>
                                      <Switch
                                        checked={
                                              rolePermission[permission._id]
                                                ? rolePermission[permission._id]
                                                : false
                                            }
                                        value={permission._id}
                                        onChange={(value) => handleChangeSwitch(
                                          permission._id,
                                          value,
                                        )}
                                      />
                                      <span>{permission.name}</span>
                                    </Space>
                                  </Menu.Item>
                                ) : (
                                  <SubMenu
                                    key={permission._id}
                                    title={(
                                      <Space>
                                        <Switch
                                          checked={
                                                rolePermission[permission._id]
                                                  ? rolePermission[permission._id]
                                                  : false
                                              }
                                          value={permission._id}
                                          onChange={(value) => handleChangeSwitch(
                                            permission._id,
                                            value,
                                          )}
                                        />
                                        <span>{permission.name}</span>
                                      </Space>
                                        )}
                                  >
                                    {permission.children
                                          && permission.children.map((child) => (child.children === 0 ? (
                                            <Menu.Item key={child._id}>
                                              <Space>
                                                <Switch
                                                  checked={
                                                      rolePermission[child._id]
                                                        ? rolePermission[child._id]
                                                        : false
                                                    }
                                                  value={child._id}
                                                  onChange={(value) => handleChangeSwitch(
                                                    child._id,
                                                    value,
                                                  )}
                                                />
                                                <span>{child.name}</span>
                                              </Space>
                                            </Menu.Item>
                                          ) : (
                                            <SubMenu
                                              key={child._id}
                                              title={(
                                                <Space>
                                                  <Switch
                                                    checked={
                                                        rolePermission[child._id]
                                                          ? rolePermission[child._id]
                                                          : false
                                                      }
                                                    value={child._id}
                                                    onChange={(value) => handleChangeSwitch(
                                                      child._id,
                                                      value,
                                                    )}
                                                  />
                                                  <span>{child.name}</span>
                                                </Space>
                                                )}
                                            >
                                              {child.children
                                                  && child.children.map((grandchild) => (
                                                    <Menu.Item key={grandchild._id}>
                                                      <Space>
                                                        <Switch
                                                          checked={
                                                              rolePermission[
                                                                grandchild._id
                                                              ]
                                                                ? rolePermission[
                                                                  grandchild._id
                                                                ]
                                                                : false
                                                            }
                                                          value={grandchild._id}
                                                          onChange={(value) => handleChangeSwitch(
                                                            grandchild._id,
                                                            value,
                                                          )}
                                                        />
                                                        <span>
                                                          {grandchild.name}
                                                        </span>
                                                      </Space>
                                                    </Menu.Item>
                                                  ))}
                                            </SubMenu>
                                          )))}
                                  </SubMenu>
                                )}
                              </Menu>
                            ))}
                          </div>
                        ))}
                      </Form.Item>
                    </Col>

                    <Row type="flex" gutter={[10, 20]} justify="space-around">
                      <Col>
                        <Button
                          loading={loading}
                          type="primary"
                          htmlType="submit"
                          className="mr-button btn-success"
                        >
                          Submit
                        </Button>
                        <Button htmlType="reset" onClick={handleReset}>
                          Reset
                        </Button>
                      </Col>
                    </Row>
                  </>
                </Row>
              </Form>
            </Card>
          </Col>
        </Row>
      </Content>
    </>
  );
}

export default CreateRole;
